import { OdataManager } from '@/api/odata/odata-manager';
import { ExternalRegister } from '@/api/model/interfaces';

export default class ExternalRegisterOdata extends OdataManager<ExternalRegister> {}
